import { type Node, type NodeProps, Position } from '@xyflow/react';
import React from 'react';

import { createHandleId } from '../../utils/handle-ids';
import { BaseNode, type NodeData } from './BaseNode';
import { NodeHandle } from './NodeHandle';

export type PDFReaderNodeType = Node<NodeData, 'custom_pdf_reader'>;

export const PDFReaderNode: React.FC<NodeProps<PDFReaderNodeType>> = ({
  id,
  data,
  selected,
}) => {
  // Extract connection state from node data for visual indicators
  const activeConnection = data.activeConnection;
  const isValidTargetHandle = data.isValidTargetHandle as
    | ((targetHandle: string) => boolean)
    | undefined;
  const isActiveConnection = !!activeConnection;

  return (
    <BaseNode
      nodeId={id}
      data={data}
      category="transform"
      subtitle="PDF to Markdown"
      selected={selected}
    >
      {/* Input handle for PDF data with connection indicators */}
      <NodeHandle
        type="target"
        position={Position.Left}
        id="pdf_data"
        blockId={id}
        isActiveConnection={isActiveConnection}
        isValidTarget={
          isValidTargetHandle
            ? isValidTargetHandle(createHandleId(id, 'pdf_data'))
            : undefined
        }
      />
      {/* Output handle for markdown text */}
      <NodeHandle
        type="source"
        position={Position.Right}
        id="markdown_text"
        blockId={id}
        isActiveConnection={isActiveConnection}
      />
    </BaseNode>
  );
};
